module.exports = __webpack_public_path__ + "static/media/bell_icon_new.7167ca79.svg";